import type { IOrder, IOrderWithCounts } from 'Model/index.js'

export const incompleteOrder: IOrder = {
  type: 'active',
  createdByUser: 'userIdHere',
  id: 'orderID-12341',
  name: 'Forst and Grass Bugs',
  orderCreated: '2024-08-15T09:45:00Z',
  targetTaxonomy: 'CO1_ANIMAL',
  processingType: 'METABARCODING',
  allowSingletons: false,
  sampleConfiguration: "SINGLE_SAMPLE_PAIRS",
}

export const testOrdersWithCounts: IOrderWithCounts[] = [
  {
    negativeControlCount: 0,
    sampleCount: 0,
    poolCount: 0,
    hasBlockingItems: false,
    order: {
      type: 'active',
      id: 'order_67890',
      createdByUser: 'userIdHere',
      name: 'Environmental Samples',
      targetTaxonomy: 'FITS2_FUNGAL',
      processingType: 'METABARCODING',
      customer: 'BioResearch Inc.',
      orderCreated: '2024-08-15T09:45:00Z',
      lab: 'Genomics Lab A',
      allowSingletons: false,
      sampleConfiguration: "SINGLE_SAMPLE_PAIRS",
    }
  },
  {
    sampleCount: 0,
    negativeControlCount: 0,
    poolCount: 0,
    hasBlockingItems: false,
    order: {
      type: 'active',
      id: 'order_24680',
      createdByUser: 'userIdHere',
      name: 'Plant Root Microbiome',
      targetTaxonomy: '_16S_BACTERIA',
      processingType: 'METABARCODING',
      customer: 'GreenAgri Solutions',
      orderCreated: '2024-09-01T14:30:00Z',
      allowSingletons: false,
      lab: 'Plant Lab B',
      sampleConfiguration: "SINGLE_SAMPLE_PAIRS",
      /*samplePools: [
                {
                    id: "pool_004",
                    orderId: "order_24680",
                    samples: [
                        {
                            id: "sample_004",
                            itemType: "SAMPLE",
                            primerLiterature: "Darwin et al, 1872",
                            forwardFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            forwardFileId: "forward_read_root001.ID",
                            reverseFileId: "reverse_read_root001.ID",
                            forwardPrimer: "CGAATC",
                            reverseFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            reversePrimer: "GCTAGT",
                            customerSampleName: "Root_001",
                        }
                    ],
                    negativeControls: [
                        {
                            id: "neg_control_004",
                            itemType: "NEGATIVE_CONTROL",
                            forwardFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            forwardFileId: "forward_read_neg004.ID",
                            reverseFileId: "reverse_read_neg004.ID",
                            forwardPrimer: "CGAATC",
                            reverseFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            reversePrimer: "GCTAGT",
                            customerSampleName: "NC_004",
                        }
                    ]
                }
            ]
        }
    },
    {
        sampleCount: 0,
        poolCount: 0,
        negativeControlCount: 0,
        order: {
            id: 'order_13579',
            createdByUser: "userIDHere",
            name: 'Human Gut Microbiome',
            targetTaxonomy: 'Bacteria',
            customer: 'HealthGenetics Ltd.',
            orderCreated: '2024-08-25T11:00:00Z',
            lab: 'Human Genomics Lab',
            allowSingletons: false,
            samplePools: [
                {
                    id: 'pool_005',
                    orderId: 'order_13579',
                    samples: [
                        {
                            id: 'sample_005',
                            primerLiterature: 'Darwin et al, 1872',
                            itemType: "SAMPLE",
                            // sampleState: "Processed",
                            forwardFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            forwardFileId: "forward_read_001.ID",
                            reverseFileId: "reverse_read_001.ID",
                            // {
                            //   id: 'file_017',
                            //   originalFileName: 'gut_forward_001.fastq',
                            //   createdAt: new Date().toISOString(),
                            //   uploadedBy: 'testUser',
                            //   resourcePath: '/path/to/resource',
                            // },
                            forwardPrimer: 'GATTAC',
                            reverseFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            // {
                            //   id: 'file_018',
                            //   originalFileName: 'gut_reverse_001.fastq',
                            //   createdAt: new Date().toISOString(),
                            //   uploadedBy: 'testUser',
                            //   resourcePath: '/path/to/resource',
                            // },
                            reversePrimer: 'CTGATC',
                            customerSampleName: 'Gut_001',
                        },
                    ],
                    negativeControls: [
                        {
                            id: 'neg_control_005',
                            itemType: "NEGATIVE_CONTROL",
                            forwardFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            forwardFileId: "forward_read_neg5.ID",
                            reverseFileId: "reverse_read_neg5.ID",
                            // {
                            //   id: 'file_019',
                            //   originalFileName: 'neg_forward_005.fastq',
                            //   createdAt: new Date().toISOString(),
                            //   uploadedBy: 'testUser',
                            //   resourcePath: '/path/to/resource',
                            // },
                            forwardPrimer: 'GATTAC',
                            reverseFile: {
                                id: "forward_read_soil001.ID",
                                orderId: "order_67890",
                                poolId: "pool_003",
                                fileName: "soil_forward_001.fastq",
                                encodedMd5: "md5",
                                location: "https://filelocation",
                                validUntil: "validUntilDateString"
                            },
                            // {
                            //   id: 'file_020',
                            //   originalFileName: 'neg_reverse_005.fastq',
                            //   createdAt: new Date().toISOString(),
                            //   uploadedBy: 'testUser',
                            //   resourcePath: '/path/to/resource',
                            // },
                            reversePrimer: 'CTGATC',
                            customerSampleName: 'NC_005',
                        },
                    ],
                },
            ],*/
    }
  }
]
